export const ActionTypes = {
  SET_LOADER_STATUS: 'services/dashboards/silosEquipmentDashboard/set_loader_status',
  FETCH_SILO_EQUIPMENT_DATA:
    'services/dashboards/silosEquipmentDashboard/fetch_silo_equipment_data',
  SET_SILO_EQUIPMENT_DATA: 'services/dashboards/silosEquipmentDashboard/set_silo_equipment_data',
};

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const fetchSiloEquipmentData = ({ silosEquipmentParams }) => ({
  silosEquipmentParams,
  type: ActionTypes.FETCH_SILO_EQUIPMENT_DATA,
});

const setSiloEquipmentData = ({ siloEquipmentData }) => ({
  siloEquipmentData,
  type: ActionTypes.SET_SILO_EQUIPMENT_DATA,
});

export default {
  setLoader,
  fetchSiloEquipmentData,
  setSiloEquipmentData,
};
